/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FulfillmentAssignmentRule = {
  readonly id?: number;
  readonly created_at?: string;
  readonly updated_at?: string;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  name: string;
  description?: string;
  is_active?: boolean;
  trigger?: FulfillmentAssignmentRule.trigger;
  conditions?: any;
  preparers?: Array<number>;
};
export namespace FulfillmentAssignmentRule {
  export enum trigger {
    ON_CLIENT_DOCS_RECEIVED = 'on_client_docs_received',
    ON_CLIENT_DOCS_ASSIGN_INTERN = 'on_client_docs_assign_intern',
    ON_CLIENT_APPROVAL_RECEIVED = 'on_client_approval_received',
  }
}
